import IconSvg, { IconSvgProps } from 'core/_legacy/icons/IconSvg'

const ForwardIcon = ({
  width = 25,
  height = 25,
  color = '#96A2C2'
}: Omit<IconSvgProps, 'children'>) => (
  <IconSvg
    style={{
      fill: color,
      width: width,
      height: height
    }}
    xmlns="http://www.w3.org/2000/svg"
    version="1.0"
    x="0px"
    y="0px"
    viewBox="0 0 50 50"
    className="icon icons8-Forward"
  >
    <g id="surface1">
      <path d="M 14.988281 3.992188 C 14.582031 3.992188 14.21875 4.238281 14.0625 4.613281 C 13.910156 4.992188 14 5.421875 14.292969 5.707031 L 33.585938 25 L 14.292969 44.292969 C 14.03125 44.542969 13.925781 44.917969 14.019531 45.265625 C 14.109375 45.617188 14.382813 45.890625 14.734375 45.980469 C 15.082031 46.074219 15.457031 45.96875 15.707031 45.707031 L 35.707031 25.707031 C 36.097656 25.316406 36.097656 24.683594 35.707031 24.292969 L 15.707031 4.292969 C 15.519531 4.097656 15.261719 3.992188 14.988281 3.992188 Z " />
    </g>
  </IconSvg>
)

export default ForwardIcon
